import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { GlobalToken } from 'antd';

export const StyledWrapper = styled.div`
    border-bottom: 1px solid rgba(37, 33, 41, 0.06);
`;

export const StyledNav = styled.nav`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 24px;
    padding-bottom: 6px;
`;

export const StyledTabsContainer = styled.div`
    flex-grow: 1;
    padding: 0 16px;
`;

export const StyledTabs = styled.div`
    display: flex;
    gap: 40px;
    font-size: 14px;
    color: rgba(37, 33, 41, 0.25);

    @media (max-width: 600px) {
        display: none;
    }
`;

interface StyledLinkProps {
    token: GlobalToken;
}

export const StyledLink = styled(NavLink)<{
    token: GlobalToken;
    $active?: boolean;
}>`
    padding-bottom: 4px;
    position: relative;
    color: ${props => props.token.colorTextBase};

    &.active {
        &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: -8px;
            border-bottom: 2px solid ${props => props.token.colorPrimary};
        }
    }
`;

export const StyledSubmenuLink = styled(StyledLink)`
    margin: 0 30px;
`;

export const StyledMobileBurger = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
